import type { ExtractFnReturnType } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { type UseQueryOptions, useQuery } from "react-query";
import type { Order } from "../models";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type QueryFnType = typeof groupActionsOrderingRepository.getOrder;
type ApiData = ExtractFnReturnType<QueryFnType>;
type UseGetBloodGetBloodTestsOptions = {
  uuid: Order["uuid"];
  config?: UseQueryOptions<ApiData, AxiosError>;
};

export const QUERY_KEY = "order";

export const useGetOrder = ({ uuid, config }: UseGetBloodGetBloodTestsOptions) => {
  const slug = useGetSlug();

  return useQuery({
    queryKey: [QUERY_KEY, slug],
    queryFn: () => groupActionsOrderingRepository.getOrder(uuid, slug),
    ...config,
  });
};
